import { IFetchTickersPayload } from '@kattana-io/common';
import { KattanaAPI, store } from '../../store/createStore';
import { actionCreateNotification } from '../../actions/notifications';
import { currentLoaderType } from './cexCurrentLoader';
import { switchCurrentTicker } from '../../Authlogic';
import { getDefaultState } from '../../reducers/current';

const dexCurrentLoader: currentLoaderType = async ({ params }) => {
  const previousState = store.getState().current;
  const address = params.address || '';
  const chain = params.chain || '';

  /**
   * Don't call tickers if user clicks on the same pair
   */
  if (
    previousState.address === address &&
    previousState.chain === chain &&
    !previousState.new
  ) {
    return null;
  }

  try {
    const payload: IFetchTickersPayload = {
      chain,
      address,
    };
    const res = await KattanaAPI.tickers(payload);
    if (res?.[0]) {
      return res[0];
    }
    store.dispatch(
      actionCreateNotification({ message: 'Market was not found' })
    );
    return switchCurrentTicker(getDefaultState());
  } catch (err) {
    console.error(err);
    store.dispatch(
      actionCreateNotification({ message: 'Market was not found' })
    );
    return switchCurrentTicker(getDefaultState());
  }
};

export default dexCurrentLoader;
